/**
 * @generated SignedSource<<7d14b8e6dbcc5a6db3342111b0dd005f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type employmentSpecialRelationshipsPastToCurrentlyQuery$variables = {
  refundHistoryId: string;
};
export type employmentSpecialRelationshipsPastToCurrentlyQuery$data = {
  readonly getSurveyEmploymentAnswer: {
    readonly employmentAnswer: {
      readonly specialRelationshipsCurrently: ReadonlyArray<{
        readonly birthday: string | null | undefined;
        readonly ieNm: string;
      }>;
      readonly specialRelationshipsInThePast: ReadonlyArray<{
        readonly attrYears: ReadonlyArray<string>;
        readonly birthday: string | null | undefined;
        readonly ieNm: string;
        readonly indvTin: string;
      }> | null | undefined;
    } | null | undefined;
    readonly result: boolean;
  };
};
export type employmentSpecialRelationshipsPastToCurrentlyQuery = {
  response: employmentSpecialRelationshipsPastToCurrentlyQuery$data;
  variables: employmentSpecialRelationshipsPastToCurrentlyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "refundHistoryId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ieNm",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "birthday",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "refundHistoryId",
        "variableName": "refundHistoryId"
      }
    ],
    "concreteType": "SurveyEmploymentAnswerOutput",
    "kind": "LinkedField",
    "name": "getSurveyEmploymentAnswer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SurveyEmploymentAnswer",
        "kind": "LinkedField",
        "name": "employmentAnswer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SurveyEmployee",
            "kind": "LinkedField",
            "name": "specialRelationshipsInThePast",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "indvTin",
                "storageKey": null
              },
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "attrYears",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EmployeeWithoutTin",
            "kind": "LinkedField",
            "name": "specialRelationshipsCurrently",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "employmentSpecialRelationshipsPastToCurrentlyQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "employmentSpecialRelationshipsPastToCurrentlyQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "2474c953b8e274757bad6be95478a90d",
    "id": null,
    "metadata": {},
    "name": "employmentSpecialRelationshipsPastToCurrentlyQuery",
    "operationKind": "query",
    "text": "query employmentSpecialRelationshipsPastToCurrentlyQuery(\n  $refundHistoryId: String!\n) {\n  getSurveyEmploymentAnswer(refundHistoryId: $refundHistoryId) {\n    result\n    employmentAnswer {\n      specialRelationshipsInThePast {\n        indvTin\n        ieNm\n        birthday\n        attrYears\n      }\n      specialRelationshipsCurrently {\n        birthday\n        ieNm\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5fd143d55cc09b5635e41bc0f048a5f0";

export default node;
